//http://www.designyourway.net/blog/resources/angularjs-boilerplates/
//https://github.com/daominhsangvn/angularjs-es6-webpack2-seed
import angular from 'angular';
import ngSanitize from 'angular-sanitize';
import ngAria from 'angular-aria';
import uiSelect from 'ui-select';
import Search from './search';
import ProductDetail from './product-detail';
import ProductRecommendation from './product-recommandation';
import CartPage from './cart-page';
import CartMini from './cart-mini';
import Common from './common';
import MobileApp from './mobile-app';
import HeaderNavigation from './header-navigation';
import HeaderCountry from './header-country';
import register from './register';
import checkout from './checkout';
import contact from './contact';
import giftcard from './giftcard';
import account from './account';
import login from './login';
import newsletter from './newsletter';
import pickup from './pickup';
import klarna from './klarna';
import yourclub from './yourclub';
import privacy from './privacy';
import wishlist from './wishlist';
import loadMoreProducts from "./product";
import AmazonPay from "./amazonpay";
import favouriteStore from './algolia';

const APP_NAME = 'lsag';
const MODULE_IMPORTS = [
    ngSanitize,
    ngAria,
    uiSelect,
    Search.name,
    ProductDetail.name,
    ProductRecommendation.name,
    CartPage.name,
    CartMini.name,
    HeaderNavigation.name,
    HeaderCountry.name,
    Common.name,
    MobileApp.name,
    register.name,
    checkout.name,
    contact.name,
    giftcard.name,
    account.name,
    login.name,
    newsletter.name,
    pickup.name,
    privacy.name,
    yourclub.name,
    wishlist.name,
    klarna.name,
    loadMoreProducts.name,
    favouriteStore.name,
    AmazonPay.name
];

angular
    .module(APP_NAME, MODULE_IMPORTS)
    .config(uiSelectConfig)
    .config(logConfig)
    .run(startup);


logConfig.$inject = ['$logProvider'];

function logConfig($logProvider) {
    if (ACC.config.debugLoggingEnabled) {
        $logProvider.debugEnabled(true);
    } else {
        $logProvider.debugEnabled(false);
    }
}

// another way to inject the dependencies
uiSelectConfig.$inject = ['uiSelectConfig'];

function uiSelectConfig(uiSelectConfig) {
    uiSelectConfig.theme = 'select2';
    uiSelectConfig.appendToBody = false;
    uiSelectConfig.searchEnabled = false;
    uiSelectConfig.skipFocusser = false;
}


function startup($templateCache, $log, CommonService) {
    'ngInject';
    $templateCache.put("select2/select.tpl.html", "<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container--open select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container--active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div><label class=\"form-control-placeholder ui-select-placeholder\" ng-bind-html='$select.placeholder'></label></div>");
    $templateCache.put("select2/match.tpl.html", "<a class=\"select2-selection select2-selection--single ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-selection__rendered\" ng-bind-html='$select.placeholder'></span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-selection__rendered select2-selection__value\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-selection__arrow\"><b></b></span></a>");
    $templateCache.put("select2/choices.tpl.html", "<span class=\"select2-results\"><ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content\"><li class=\"ui-select-choice\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul class=\"select2-results__options\" id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"select2-results__option ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul></span>");
    CommonService.personalRequest();
}

angular.element(() => {
    if (!window.frameElement) {
        console.debug('### bootstrapping angular ###');
        angular.bootstrap(document, [APP_NAME]);
    } else {
        console.debug(`### smartedit active, don't boot angular  ###`);
        // hack to prevent angularjs from analyzing and compiling the DOM starting from this point
        // maybe there are negative side effects under the smartedit environment
        document.querySelector('body').classList.add('ng-non-bindable');
        // angular.module('smartedit', [HeaderNavigation.name]);
        // window.smartedit.applications = [HeaderNavigation.name];
    }
});

// TODOs:
// 1. maybe we need some session timeout handling. See redbull project or http://www.webdeveasy.com/interceptors-in-angularjs-and-useful-examples/
// 2. use $logProvider to disable login on live environment. See redbull project or http://realeyes.com/blog/2014/04/using-the-angularjs-logprovider/
